module.exports = (__webpack_require__(36612))(8080);